import React from 'react'
import {Box, Flex, Grid} from '@chakra-ui/react'
import {remCalc} from '../../../theme/_utils'
import MenuGroupedCategories from '../../list-menu/partials/MenuGroupedCategories'
import MenuVerticalCard from '../../list-menu/partials/MenuVerticalCard'
import {getTemplateLinks} from '../../list-menu/partials/templates/shared'
import {
    DrawerLinkButtons,
    drawerBottomPadding,
    drawerTemplatePropTypes,
    fullHeightChildSx,
    templateGridGap,
    templateGridGapSx,
} from './shared'

export const getDrawerTemplateTwoData = (primarycategory) => {
    const singleCard = Array.isArray(primarycategory?.images)
        ? primarycategory.images[0]
        : primarycategory?.images

    return {
        categoryGroup: primarycategory?.category_group ?? [],
        links: getTemplateLinks(primarycategory),
        card: singleCard ?? null,
    }
}

const DrawerTemplateTwo = ({primarycategory, categoryData, locale, styles}) => {
    const {categoryGroup, links, card} = getDrawerTemplateTwoData(primarycategory)

    return (
        <Box w="100%" pb={drawerBottomPadding} data-primarycategory-id={primarycategory?.uid}>
            <Grid
                templateColumns={{base: '1fr', sm: '1fr', md: '1fr 2fr'}}
                gap={templateGridGap}
                sx={templateGridGapSx}
                alignItems="start"
            >
                <Flex
                    flexDir="column"
                    gap={templateGridGap}
                    sx={templateGridGapSx}
                    gridColumn={{base: '1 / -1', sm: '1 / -1', md: '1 / 2'}}
                >
                    {categoryData && categoryGroup.length > 0 && (
                        <MenuGroupedCategories
                            groupedCategories={categoryGroup}
                            locale={locale}
                            categoryData={categoryData}
                            styles={styles}
                            groupLinkGap={remCalc(8)}
                        />
                    )}

                    {links.length > 0 && (
                        <Flex flexDir="column" gap={2}>
                            <DrawerLinkButtons
                                links={links}
                                categoryData={categoryData}
                                locale={locale}
                                styles={styles}
                            />
                        </Flex>
                    )}
                </Flex>

                {card && (
                    <Box
                        gridColumn={{base: '1 / -1', sm: '1 / -1', md: '2 / 3'}}
                        w="100%"
                        h={{base: 'auto', sm: 'auto', md: remCalc(468)}}
                        minH={{md: remCalc(468)}}
                        maxH={{md: remCalc(468)}}
                        aspectRatio={{base: 1.3, sm: 1.3, md: 'auto'}}
                        sx={fullHeightChildSx}
                    >
                        <MenuVerticalCard
                            card={card}
                            categoriesData={categoryData}
                            locale={locale}
                        />
                    </Box>
                )}
            </Grid>
        </Box>
    )
}

DrawerTemplateTwo.propTypes = drawerTemplatePropTypes

export default DrawerTemplateTwo
